import React from "react";

/**
 * Marca del sitio: gota de agua + wordmark.
 * `variant="light"` para fondos oscuros (hero, footer).
 */
const Logo = ({ variant = "dark", className = "" }) => {
  const light = variant === "light";

  return (
    <a
      href="#inicio"
      aria-label={`Riego Mercedes — ir al inicio`}
      className={`group flex items-center gap-2.5 ${className}`}
    >
      <span
        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg transition-transform duration-200 group-hover:scale-105 ${
          light ? "bg-white/15 backdrop-blur-sm" : "bg-campo-700"
        }`}
      >
        {/* Gota de agua */}
        <svg
          viewBox="0 0 24 24"
          className="h-5 w-5 text-white"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M12 2.5c-.32 0-.62.15-.81.4C10.4 3.87 5 11.06 5 14.86 5 18.8 8.13 22 12 22s7-3.2 7-7.14c0-3.8-5.4-10.99-6.19-11.96a1.02 1.02 0 0 0-.81-.4Zm-1.6 15.7a4.4 4.4 0 0 1-2.62-2.9.75.75 0 0 1 1.45-.38 2.9 2.9 0 0 0 1.72 1.9.75.75 0 0 1-.55 1.39Z" />
        </svg>
      </span>
      <span className="flex flex-col leading-none">
        <span
          className={`font-display text-lg font-extrabold tracking-tight ${
            light ? "text-white" : "text-campo-950"
          }`}
        >
          Riego Mercedes
        </span>
        <span
          className={`mt-0.5 text-[10px] font-semibold uppercase tracking-[0.16em] ${
            light ? "text-campo-200" : "text-campo-700"
          }`}
        >
          Tecnología de riego
        </span>
      </span>
    </a>
  );
};

export default Logo;
